import React, {useEffect, useState, useRef} from 'react';
import {Box, Spinner, useDimensions} from '@chakra-ui/react';
import TeamHero from './Team/Components/Hero';
import TeamList from './Team/Components/List';
import TeamNav from './Team/Components/Nav';
import axios from "axios";
import {SEO} from "../components/SEO";
import FullCrossPlus from "../components/FullCrossPlus";
import {useRecoilState} from "recoil";
import {teamState} from "../states";

const TeamScreen = (props) => {
    const [metaData, setMetaData] = useState(undefined)
    const [teamData] = useRecoilState(teamState)
    const [categoriesData, setCategoriesData] = useState(undefined)
    const pageRef = useRef();
    const dimen = useDimensions(pageRef, true);

    const count = Math.floor(dimen?.contentBox.height / 393) || 5;

    useEffect(() => {
        const fetchTeamData = async () => {
            const metaResponse = await axios.get('/wp-json/wp/v2/pages?acf_format=standard&slug=team').then(resp => {
                return resp.data;
            });
            const categoriesResponse = await axios.get('/wp-json/wp/v2/team?_fields%5B%5D=slug&_fields%5B%5D=name&_fields%5B%5D=count&per_page=100').then(resp => {
                return resp.data;
            });
            setCategoriesData(categoriesResponse)
            setMetaData(metaResponse[0])
        }
        fetchTeamData()
    }, [])

    const isMobile = dimen?.contentBox.width < 768;

    return (
        <>
            <SEO
                image={metaData?.yoast_head_json?.og_image?.length > 0 ? metaData?.yoast_head_json?.og_image[0]?.url : null}
                title={metaData?.title?.rendered}
                ogTitle={metaData?.yoast_head_json?.og_title}
                description={metaData?.yoast_head_json?.og_description || metaData?.excerpt?.rendered}
                url={metaData?.yoast_head_json?.og_url}
                type={metaData?.yoast_head_json?.og_type}
                siteName={metaData?.yoast_head_json?.og_site_name}
                robots={`${metaData?.yoast_head_json?.robots.index}, ${metaData?.yoast_head_json?.robots.follow}`}
            />
            <Box ref={pageRef}>
                {!isMobile && Array(count)
                    .fill('')
                    .map((_, key) => (
                        <FullCrossPlus index={key + 1} top={393 * (key + 1)} key={key}/>
                    ))}
                <Box px={['5', '10']}>
                    {(!teamData || !categoriesData) ?
                        (
                            <Box my={20}>
                                <Spinner color='blue.600' size='xl'/>
                            </Box>
                        )
                        :
                        (<>
                            <TeamHero data={metaData}/>
                            <TeamNav data={teamData} slug={props.slug} categoriesData={categoriesData}/>
                            <TeamList data={teamData} categoriesData={categoriesData}/>
                        </>)
                    }
                </Box>
            </Box>
        </>
    );
};

export default TeamScreen;
